import rustoreIcon from '@/assets/images/rustore.svg'
import appstoreIcon from '@/assets/images/appstore.svg'

import appstoreQR from '@/assets/images/qr-appstore.png'
import rustoreQR from '@/assets/images/qr-rustore.png'

const RUSTORE_URL = 'https://rustore.ru/catalog/app/pro.uchi.uchi'
const APP_STORE_URL = 'https://apps.apple.com/us/app/учи-про/id6745216702'

export default {
  data () {
    return {
      rustoreIcon,
      appstoreIcon,
      rustoreQR,
      appstoreQR,
      rustoreUrl: RUSTORE_URL,
      appstoreUrl: APP_STORE_URL
    }
  }
}
